"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPrefixedThemeBundleId = buildPrefixedThemeBundleId;
const enums_1 = require("@aurora/shared-types/overrides/enums");
function buildBundleId(themeId, lastModified) {
    return `${themeId}-${lastModified !== null && lastModified !== void 0 ? lastModified : 0}`;
}
/**
 * Builds an identifier to be used as an Apollo cache key for Theme assets
 * @param themeId theme identifier
 * @param lastModified last modified timestamp
 */
function buildPrefixedThemeBundleId(themeId, lastModified) {
    return `${enums_1.CachedAssetType.THEME}:${buildBundleId(themeId, lastModified)}`;
}
//# sourceMappingURL=ApolloThemeCacheHelper.js.map